module.exports = __webpack_public_path__ + "img/dd25bd1.png";